
import React, { useState } from 'react';
import grinderClosed from '../assets/store/grinder closed.png';
import grinderOpen from '../assets/store/grinder open.png';
import grinderHalf from '../assets/store/grinder half.png';
import grinderDetail1 from '../assets/store/grinder detail 1.jpeg';
import grinderDetail2 from '../assets/store/grinder detail 2.jpeg';

export default function ProductCard({ product, onClick }) {
  const [hovered, setHovered] = useState(false);
  // Find the index of 'grinder half.png' in the images array
  const halfIdx = product.images.findIndex(img => img === 'grinder half.png');
  const imgIdx = hovered && halfIdx !== -1 ? halfIdx : 0;
  // Map image filenames to imported images
  const imageMap = {
    // 'grinder closed.png': grinderClosed,
    'grinder open.png': grinderOpen,
    'grinder half.png': grinderHalf,
    'grinder detail 1.jpeg': grinderDetail1,
    'grinder detail 2.jpeg': grinderDetail2,
  };
  return (
    <div
      className="product-card"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onTouchStart={() => setHovered(true)}
      onTouchEnd={() => setHovered(false)}
    >
      <div className="product-image" aria-hidden>
        <img src={imageMap[product.images[imgIdx]]} alt={product.code} />
      </div>
      <div className="product-code">{product.code}</div>
    </div>
  );
}
